<template>
  <div id="video">
    <div class="video">
      <video
        ref="videoPlayer"
        class="video-js vjs-default-skin vjs-big-play-centered"
        x-webkit-airplay="true"
        webkit-playsinline=""
        playsinline="true"
      ></video>
      <div class="info">
        <div class="title">{{ video.title }}</div>
        <van-tag type="primary" plain v-if="video.hasWatched == 0"
          >未观看</van-tag
        >
        <van-tag type="success" plain v-else>已完成</van-tag>
      </div>
      <div class="van-hairline--top notice">
        <van-notice-bar
          wrapable
          :scrollable="false"
          left-icon="volume-o"
          text="温馨提示：观看视频后，即可参与抽奖（每人每天上限1次）！奖品池又追加了，爱仕达奶锅、珐琅手工艺品、儿童餐盘礼盒、马克笔、帆布袋等你来拿！"
        ></van-notice-bar>
      </div>
    </div>
    <van-overlay
      v-if="!isLottery"
      :show="showLottery"
      @click="showLottery = false"
      class="lottery"
    >
      <div class="wrapper" @click.stop>
        <LuckyWheel
          ref="myLucky"
          width="300px"
          height="300px"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          @start="startCallback"
          @end="endCallback"
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import VueLuckyCanvas from '@lucky-canvas/vue'
import 'video.js/dist/video-js.css'
import { getVideoDetail } from '@/api/fanzha'
import { hasDraw } from '@/api/fanzha'
import {
  getPrizeList,
  getFanzhaUserInfo,
  saveVideoHistory,
  draw
} from '@/api/fanzha'
import { Dialog, NoticeBar } from 'vant'

import videojs from 'video.js'

Vue.use(VueLuckyCanvas)

export default {
  name: 'Video',
  data() {
    return {
      winPrizeId: 0,
      winPrizeName: '',
      prizes: [],
      showLottery: false,
      blocks: [{ padding: '13px', background: '#FDE52D' }],
      buttons: [
        { radius: '50px', background: '#F87F02' },
        { radius: '45px', background: '#ffffff' },
        {
          radius: '40px',
          background: '#D43128',
          pointer: true,
          fonts: [{ text: '开始\n抽奖', top: '-20px' }]
        }
      ],
      lotterying: false,
      prizeRecord: {},
      afterReturnRand: {},
      isLottery: false,
      video: {},
      options: {
        height: 230,
        autoplay: false,
        controls: true,
        controlBar: {
          playToggle: true,
          captionsButton: false,
          chaptersButton: false,
          subtitlesButton: false,
          remainingTimeDisplay: true,
          progressControl: {
            seekBar: false
          },
          fullscreenToggle: false,
          playbackRateMenuButton: false
        },
        poster: '',
        sources: [
          {
            src: '',
            type: 'video/mp4'
          }
        ]
      },
      themeId: 1
    }
  },
  created() {
    getVideoDetail({ id: this.$route.params.id }).then((res) => {
      if (res.code == 1) {
        this.video = {
          id: this.$route.params.id,
          status: 0,
          title: res.data.title,
          poster: res.data.cover,
          src: res.data.url,
          hasWatched:res.data.hasWatched
        }
        this.options.poster = this.video.poster
        this.options.sources[0].src = this.video.src
        let self = this
        this.player = videojs(
          this.$refs.videoPlayer,
          this.options,
          function onPlayerReady() {
            console.log('onPlayerReady', this)
            // this.controlBar.progressControl.disable();
            this.on('ended', () => {
              self.onPlayEnded()
            })
          }
        )
      }
    })
  },
  mounted() {
    getFanzhaUserInfo().then((res) => {
      if (res.code == 1 && res.data == null) {
        this.$route.push({
          path: `/fzp/list`
        })
      }
    })
    //判断今天是否抽过奖
    hasDraw({ type: 1 }).then((res) => {
      if (res.code == 1) {
        this.isLottery = res.data.hasDraw
      }
    })
    //获取奖品列表
    getPrizeList().then((res) => {
      if (res.code == 1) {
        console.log(res.data)
        for (let i = 0; i <= res.data.length; i++) {
          let prize = {
            fonts: [
              {
                text: res.data[i].prizeName,
                top: '10%',
                fontSize: 13,
                lengthLimit: 60
              }
            ]
          }
          if (res.data[i].id == 0) {
            prize.background = '#EBEBEB'
          } else if (i % 2 == 0) {
            prize.background = '#FFF4D6'
          } else {
            prize.background = '#FFFFFF'
          }
          this.prizes.push(prize)
        }
      }
    })
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    onPlayEnded() {
      if (this.video.status == 0) {
        this.video.status = 1
      }
      //上报视频播放记录
      saveVideoHistory({ videoId: this.$route.params.id }).then((res) => {
        console.log('上报视屏播放记录')
      })
      if (this.video.status == 0) {
        this.video.status = 1
      }
      console.log('ended')
      //判断时间是否2月26号之前 26号之前
      var time = new Date().getTime();
      if(time <= 1645804800000) {
          this.showLottery = true
      }
    },
    // 点击抽奖按钮会触发star回调
    startCallback() {
      if (this.lotterying) return false
      this.lotterying = true

      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play()

      draw({ type: 1 }).then((res) => {
        if (res.code == 1 && res.data.prize != null) {
          this.winPrizeId = res.data.prize.id
          this.winPrizeName = res.data.prize.prizeName
          this.$refs.myLucky.stop(res.data.prize.id - 1)
          this.lotterying = false
        } else {
          this.$refs.myLucky.stop(this.prizes.length-1)
          this.lotterying = false
          //Dialog.alert({ message: res.msg });
        }
      })
      // TODO: ajax获得转盘结果
      /*
      getPrizeRand({
        theme_id: this.$route.params.id,
        record_id: this.prizeRecord.id
      }).then((res) => {
        // console.log(res)
        if (res.code == 1) {
          let result = res.data

          const index = result.index
          // 调用stop停止旋转并传递中奖索引
          this.$refs.myLucky.stop(index)

          this.afterReturnRand = res
        } else {
          Toast.fail(res.msg)
        }
        this.lotterying = false
      })
      */
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      console.log(prize)
      var dMsg = '明天再来'
      if (this.winPrizeName != '') {
        dMsg = '恭喜你获得' + this.winPrizeName + ' x 1'
      }
      Dialog.alert({ message: dMsg }).then(() => {
        this.showLottery = false
        this.isLottery = true
        this.showTestAgain = true
      })
      // console.log('end', prize)
      /*
      this.prizeRecord.status = '1'
      let result = this.afterReturnRand.data
      if (result.is_win) {
        // 中奖了，信息登记
        Toast.success(this.afterReturnRand.msg)
        this.showLottery = false
        this.myPrize = result.title
        this.$nextTick(() => {
          this.showWinnerForm = true
        })
      } else {
        this.showLottery = false
        Toast({ message: this.afterReturnRand.msg, duration: 4000 })
      }
      */
    }
  }
}
</script>

<style lang="less" scoped>
.video-js {
  width: 100%;
}

.video {
  .info {
    padding: 5px;
    margin-bottom: 10px;
  }
  .notice {
    padding-top: 10px;
  }
}

.lottery {
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
